module.exports = __webpack_public_path__ + "img/service-details-1.d663b33e.jpg";